module.exports = __webpack_public_path__ + "static/media/logo.1cab036e.png";